import { FHIRModel } from '@ctw/shared/api/fhir/models/fhir-model';
import { getBinaryIDFromProvenance } from '@ctw/shared/api/fhir/provenance';
import type { ResourceMap } from '@ctw/shared/api/fhir/types';
import type { Basic, Procedure, Provenance } from 'fhir/r4';

export class ProcedureModel extends FHIRModel<Procedure> {
  public kind = 'Procedure' as const;

  public binaryId?: string;
  public provenance?: Array<Provenance>;

  public constructor(
    resource: Procedure,
    provenance?: Array<Provenance>,
    includedResources?: ResourceMap,
    basics?: Array<Basic>,
  ) {
    super(resource, includedResources, basics);
    this.provenance = provenance;
    this.binaryId = getBinaryIDFromProvenance(this.provenance);
  }

  public get title() {
    return this.resource.code?.text ?? 'Unknown Procedure';
  }

  public get date() {
    return this.resource.performedDateTime ?? this.resource.performedPeriod?.start;
  }

  public get binary() {
    return this.binaryId;
  }
}
